/** Lead -> organisation conversion (ORG-019, SD-S4-07): codes shared with the API (`app/core/constants/service_desk_migration.py`). */

/** The lead activity the conversion writes; its `data` holds `organisation_id` and `contact_id`. */
export const LEAD_CONVERTED_ACTIVITY = "converted_to_organisation";

/** `error.details.reason` values the dialog words itself. */
export const LEAD_CONVERT_REASON = {
  alreadyConverted: "already_converted",
  duplicatesFound: "duplicates_found",
} as const;

/** Custom lead fields that usually hold a company name; the first one with text prefills the organisation name. */
export const LEAD_COMPANY_FIELDS = ["organisation", "organization", "company", "school", "institution"] as const;

export const LEAD_DOMAIN_SEPARATOR = /[\s,;]+/;
